import { Skeleton } from '@mokoboko/components';
import type { OfferingFacts } from '@/helpers/offering-facts';
import { mergeClassNames } from '@/lib/utils';
import { FactPill, LoneFactPill } from './fact-pill';
import { FactTiles } from './fact-tiles';

const loneTileOf = (facts: OfferingFacts) =>
  facts.tiles.length === 1 ? facts.tiles[0] : null;

// The pills under the title; on a phone the tiles follow them in one box.
export const OfferingHeroFacts = ({ facts }: { facts: OfferingFacts }) => {
  const loneTile = loneTileOf(facts);
  if (facts.pills.length === 0 && facts.tiles.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      {(facts.pills.length > 0 || loneTile) && (
        <div
          className={mergeClassNames(
            'grid grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:items-center',
            facts.pills.length === 0 && 'max-sm:hidden'
          )}
        >
          {facts.pills.map((pill) => (
            <FactPill key={pill} boxOnPhone>
              {pill}
            </FactPill>
          ))}
          {loneTile && <LoneFactPill tile={loneTile} />}
        </div>
      )}
      {facts.tiles.length > 0 && (
        <FactTiles tiles={facts.tiles} compact className="sm:hidden" />
      )}
    </div>
  );
};

export const OfferingHeroFactsSkeleton = () => (
  <div className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:items-center">
    <Skeleton
      isRounded
      className="!h-16 w-full !rounded-xl sm:!h-9 sm:w-24 sm:!rounded-full"
    />
    <Skeleton
      isRounded
      className="!h-16 w-full !rounded-xl sm:!h-9 sm:w-20 sm:!rounded-full"
    />
  </div>
);

export const OfferingFactTiles = ({ facts }: { facts: OfferingFacts }) =>
  facts.tiles.length > 0 && !loneTileOf(facts) ? (
    <FactTiles tiles={facts.tiles} className="max-sm:hidden" />
  ) : null;
